import React, { useEffect } from "react";
import Filter from "./Filter";
import Loading from "../../../../components/ui/Loading/Loading";
import { FAQTable } from "./faq-table";
import Button from "../../../../components/ui/Button/Button";
import { useNavigate } from "react-router-dom";
import { useFAQCategory } from "../../../../api/inquiries/faq/use-faq-category";

const FAQBB = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("hospitalName");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };

  const { data: faqCategorys } = useFAQCategory({ status: "ON" });

  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };
  const onChangeClassification = (id) => {
    setSelectedFilter({
      ...selectedFilter,
      classification: id,
    });
  };

  const onSubmitFilter = () => {
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  const handleAddFAQ = () => {
    navigate("faq/register");
  };
  const handleToManage = () => {
    navigate("faq/management");
  };

  return (
    <>
      <div className="flex justify-end mt-4">
        <Button text="분류 유형 관리" onClick={handleToManage} />
        <Button margin="mr-0" primary text="FAQ 등록" onClick={handleAddFAQ} />
      </div>
      {isResetting ? (
        <Loading />
      ) : (
        <>
          {isResetted ? (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
              placeholderClassification="전체"
              classificationOptions={faqCategorys?.data ?? []}
              onChangeClassification={onChangeClassification}
            />
          ) : (
            <Filter
              onSubmitFilter={onSubmitFilter}
              filter={selectedFilter}
              onFilter={setSelectedFilter}
              onResetFilter={onResetFilter}
              onChangeSearchBy={onChangeSearchBy}
              onChangeSearchByValue={onChangeSearchByValue}
              placeholderClassification="전체"
              classificationOptions={faqCategorys?.data ?? []}
              onChangeClassification={onChangeClassification}
            />
          )}
        </>
      )}
      <FAQTable filter={isResetted ? resettedFilter : filters} />
    </>
  );
};

export default FAQBB;
